import {
  MYDOCUMENTS_ALL,
  MYDOCUMENTS_ASSIGNEDTOME,
  MYDOCUMENTS_ASSIGNEDTOOTHERS,
  MYDOCUMENTS_COMPLETED,
  MYDOCUMENTS_ERROR,
  MYDOCUMENTS_WIP,
  MYDOCUMENTS_MOVETOWIP,
  MYDOCUMENTS_DOWNLOADCOMP_INI,
  MYDOCUMENTS_DOWNLOADCOMP,
  MYDOCUMENTS_DOWNLOADCOMP_FAILED,
  MYDOCUMENTS_UPLOADCOMP_INI,
  MYDOCUMENTS_UPLOADCOMP,
  MYDOCUMENTS_UPLOADCOMP_FAILED,
  MYDOCUMENTS_UPLOADFILEUPDATE,
  MYDOCUMENTS_ACCEPTORREJECT,
  MYDOCUMENTS_GETASSIGNLIST,
  MYDOCUMENTS_REASSIGN,
  MYDOCUMENTS_REASSIGN_CLEAR,
  MYDOCUMENTS_REVOKE,
  MYDOCUMENTS_DELERROR,
  GET_COMPANY_TAGS,
  GET_TOP_ISSUES,
  GET_FILE_HISTORY,
  VIEW_SUMMARY_LINK,
  INSERT_TAG,
  APPLY_TAG,
  CHECK_FIX_OPR,
  RESET_CHECK_FIX_OPR,
  FILE_UPDATE,
  FILE_UPDATE_CLEAR,
  FILE_DELETE,
  FILE_DELETE_CLEAR,
  VALIDATIONSTANDARD_WIP,
  UPDATE_VALIDATIONSTANDARD_WIP,
  FILE_UPLOAD_VERIFY,
  MYDOCUMENTS_SHARE,
  GET_S2_LINK,
  UPDATED_FILE,
  RESET_SHARE_DATA,
  RESET_TAG_DATA,
  MYDOCUMENT_MOVETOWIP_CLEAR,
  MYDOCUMENTS_FILE_DELETE_CLEAR,
  USER_NOTIFICATION,
  TEST_CONNECTION,
  GET_FTP_SFTP_CONFIG,
  ADD_FTP_SFTP_CONFIG,
  UPDATE_FTP_SFTP_CONFIG,
  REMOVE_TOASTER_MSG,
  SHOW_FTP_SFTP_LOADER,
  ADD_UPLOADED_FILES,
  UPDATE_UPLOAD_PROGRESS,
  CLEAR_UPLOAD_PROGRESS,
  MYDOC_CURRENT_TAB,
  LICENSE_CONSUMPTION_SUCCESS,
  LICENSE_CONSUMPTION_FAILURE,
  LICENSE_MESSAGE_CLEAR,
  CHECK_FIX_OPR_FAIL,
  CHECK_FIX_OPR_FAIL_CLEAR,
  LICENSE_CONSUMPTION_REVIEW_FAILURE,
  LICENSE_CONSUMPTION_REVIEW_FAILURE_CLEAR,
} from '../actions/MydocumentsActions'

import uuid from 'react-uuid'

const initialState = {
  //fileCount: {},

  downloadComp: {},
  getAssignList: [],
  showFtpSftpLoader: false,
  uploadedFiles: [],
  uploadProgress: {},
  myDocActiveTab: 'Work in Progress',
  //fileCount: {},
  licenseConsumptionRes: false,
}

const mydocumentsReducer = function (state = initialState, action) {
  switch (action.type) {
    case MYDOCUMENTS_ALL:
      state = {
        ...state,
        myDocsAll: action.payload?.data,
      }
      break
    case MYDOCUMENTS_COMPLETED:
      state = {
        ...state,
        myDocsComp: action.payload?.data,
      }
      break
    case MYDOCUMENTS_ASSIGNEDTOME:
      console.log('MyDoc Assigned Me :::', action.payload)
      state = {
        ...state,
        myDocsAssignedMe: action.payload?.data,
      }
      break
    case MYDOCUMENTS_ASSIGNEDTOOTHERS:
      state = {
        ...state,
        myDocsAssignedOthers: action.payload?.data,
      }
      break
    case MYDOCUMENTS_ERROR:
      state = {
        ...state,
        myDocsError: action.payload?.data,
      }
      break
    case MYDOCUMENTS_WIP:
      state = {
        ...state,
        myDocsWip: action.payload?.data,
        myDocsCount: action.payload?.totalCount,
      }
      break
    case MYDOCUMENTS_MOVETOWIP:
      let outData = { uuid: uuid(), status: action.payload?.data }
      console.log('move to wip', outData)

      state = {
        ...state,
        movetoWip: outData,
      }
      break

    case MYDOCUMENT_MOVETOWIP_CLEAR:
      state = {
        ...state,
        movetoWip: undefined,
      }
      break

    case MYDOCUMENTS_DOWNLOADCOMP:
      state = {
        ...state,
        downloadComp: action.payload?.data,
      }
      break

    case MYDOCUMENTS_ACCEPTORREJECT:
      let unique = uuid()
      state = {
        ...state,
        fileAcceptOrReject: action.payload?.data + ' - ' + unique,
      }
      break
    case MYDOCUMENTS_GETASSIGNLIST:
      state = {
        ...state,
        getAssignList: action.payload?.data,
      }
      break

    // case   MYDOCUMENTS_REASSIGN :
    //   state = {
    //     ...state,
    //     reAssignOthers: action.payload?.data,
    //   }
    //   break
    case MYDOCUMENTS_REVOKE:
      state = {
        ...state,
        revokeOthers: action.payload?.data,
      }
      break
    case MYDOCUMENTS_DELERROR:
      state = {
        ...state,
        delError: action.payload?.data,
      }
      break
    case MYDOCUMENTS_FILE_DELETE_CLEAR:
      state = {
        ...state,
        delError: undefined,
      }
      break

    case GET_COMPANY_TAGS:
      state = {
        ...state,
        companyTags: action.payload?.data,
      }
      break
    case GET_TOP_ISSUES:
      state = {
        ...state,
        topIssues: action.payload?.data,
      }
      break
    case GET_FILE_HISTORY:
      state = {
        ...state,
        fileHistory: action.payload?.data,
      }
      break

    case VIEW_SUMMARY_LINK:
      console.log('Summary Link', action.payload?.data)
      state = {
        ...state,
        viewSummary: action.payload?.data,
      }
      break

    case INSERT_TAG:
      state = {
        ...state,
        newTag: action.payload?.data,
      }
      break

    case APPLY_TAG:
      console.log(' addFileResult ', action.payload)
      state = {
        ...state,
        addFileResult: action.payload,
      }
      break
    case CHECK_FIX_OPR:
      state = {
        ...state,
        checkFixMsg: action.payload,
      }
      break
    case CHECK_FIX_OPR_FAIL:
      console.log('CHECKFIX FAIL RES REDUCER', action.payload)
      state = {
        ...state,
        checkFixFailMsg: action.payload,
      }
      break

    case RESET_CHECK_FIX_OPR:
      console.log(' checkFixMsg ', action.payload)
      state = {
        ...state,
        checkFixMsg: undefined,
      }
      break

    case RESET_TAG_DATA:
      state = {
        ...state,
        addFileResult: undefined,
      }
      break

    case FILE_UPDATE:
      console.log(' FILE_UPDATE  ', action.payload)
      state = {
        ...state,
        fileOperations: action.payload,
      }
      break

    case FILE_UPDATE_CLEAR:
      state = {
        ...state,
        fileOperations: undefined,
      }
      break
    case FILE_DELETE:
      console.log(' FILE_DELETE  ', action.payload)
      state = {
        ...state,
        fileDeleteMsg: action.payload,
      }
      break

    case FILE_DELETE_CLEAR:
      state = {
        ...state,
        fileDeleteMsg: undefined,
      }
      break

    case MYDOCUMENTS_REASSIGN:
      state = {
        ...state,
        reAssignOthers: action.payload?.responseMessage,
      }
      break
    case MYDOCUMENTS_REASSIGN_CLEAR:
      state = {
        ...state,
        reAssignOthers: undefined,
      }
      break
    case MYDOCUMENTS_REVOKE:
      state = {
        ...state,
        revokeOthers: action.payload?.data,
      }
      break
    case MYDOCUMENTS_DELERROR:
      state = {
        ...state,
        delError: action.payload?.data,
      }
      break
    case MYDOCUMENTS_SHARE:
      state = {
        ...state,
        allShare: action.payload,
      }
      break
    case RESET_SHARE_DATA:
      state = {
        ...state,
        allShare: undefined,
      }
      break

    case VALIDATIONSTANDARD_WIP:
      state = {
        ...state,
        validationStandardResponse: action.payload?.data,
      }
      break
    case UPDATE_VALIDATIONSTANDARD_WIP:
      console.log('WIP uPDATE validation standard Response:', action.payload)
      state = {
        ...state,
        updateValidationStandardResponse: action.payload,
      }
      break
    case FILE_UPLOAD_VERIFY:
      console.log('Upload Verify:', action.payload)
      state = {
        ...state,
        fileUploadVerifyResponse: action.payload,
      }
      break

    case GET_S2_LINK:
      state = {
        ...state,
        uploadCred: action.payload,
      }
      break
    case UPDATED_FILE:
      state = {
        ...state,
        updatedRecord: action.payload.data,
      }
      break

    case USER_NOTIFICATION:
      let notifications = []

      // if (action.payload?.data?.length > 0) {
      //   notifications = action.payload?.data?.filter(
      //     (msg) =>
      //       msg.operation == 'Reassigned File' ||
      //       msg.operation == 'Revoked assigned file' ||
      //       msg.operation == 'Reject assigned file' ||
      //       msg.operation == 'Completed assigned file' ||
      //       msg.operation == 'Alt text export completed',
      //   )
      // }
      state = {
        ...state,
        notification: action.payload?.data,
      }
      break
    case GET_FTP_SFTP_CONFIG:
      state = {
        ...state,
        ftpSftpConfig: action.payload.data,
        showFtpSftpLoader: false,
      }
      break
    case TEST_CONNECTION:
      state = {
        ...state,
        connectionStatus: action.payload,
        showToasterMsg: true,
        connectionTested: true,
        showFtpSftpLoader: false,
      }
      break
    case ADD_FTP_SFTP_CONFIG:
      state = {
        ...state,
        createFtpSftpConfig: action.payload,
        showToasterMsg: true,
        configAdded: true,
        showFtpSftpLoader: false,
      }
      break
    case UPDATE_FTP_SFTP_CONFIG:
      state = {
        ...state,
        updateFtpSftpConfig: action.payload,
        showToasterMsg: true,
        configUpdated: true,
        showFtpSftpLoader: false,
      }
      break
    case REMOVE_TOASTER_MSG:
      state = {
        ...state,
        showToasterMsg: false,
        connectionTested: false,
        configAdded: false,
        configUpdated: false,
        showFtpSftpLoader: false,
      }
    case SHOW_FTP_SFTP_LOADER:
      state = {
        ...state,
        showFtpSftpLoader: action.payload,
      }
    case ADD_UPLOADED_FILES:
      state = {
        ...state,
        uploadedFiles: action.payload,
      }
      break
    case UPDATE_UPLOAD_PROGRESS:
      state = {
        ...state,
        uploadProgress: { ...state.uploadProgress, ...action.payload },
      }
      break
    case CLEAR_UPLOAD_PROGRESS:
      state = {
        ...state,
        uploadedFiles: [],
        uploadProgress: {},
      }
      break

    case MYDOC_CURRENT_TAB:
      state = {
        ...state,
        myDocActiveTab: ['Work in Progress', 'Completed', 'ATOM', 'ALL', 'Error', 'All'][
          action.payload
        ],
      }
      break
    case LICENSE_CONSUMPTION_SUCCESS:
      state = {
        ...state,
        licenseConsumptionRes: action.payload,
      }
      break
    case LICENSE_CONSUMPTION_FAILURE:
      state = {
        ...state,
        licenseConsumptionFailRes: action.payload,
      }
      break
    case LICENSE_CONSUMPTION_REVIEW_FAILURE:
      state = {
        ...state,
        licenseConsumptionReviewFailRes: action.payload,
      }
      break
    case LICENSE_MESSAGE_CLEAR:
      state = {
        ...state,
        licenseConsumptionFailRes: undefined,
      }
      break
    case CHECK_FIX_OPR_FAIL_CLEAR:
      state = {
        ...state,
        checkFixFailMsg: undefined,
      }
      break
    case LICENSE_CONSUMPTION_REVIEW_FAILURE_CLEAR:
      state = {
        ...state,
        licenseConsumptionReviewFailRes: undefined,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
export default mydocumentsReducer
